import { ProviderType } from 'features/connections'
import { TreeObjectType } from '../types'
import { getDataExplorerObject, getSubscriptionDates, searchTableInConnection } from './dataExplorer'

// TODO: should we use this hook instead calling saga in Analysis ¿?
export function getDataExplorerObjectQuery(fqdn: string, connectionId: string) {
  return {
    queryKey: ['table', fqdn, connectionId],
    queryFn: () => {
      return getDataExplorerObject({
        link: `/connections/${connectionId}/resources/${fqdn}?type=${TreeObjectType.Table}`
      })
    }
  }
}

export function getSubscriptionDatesQuery(fqn: string) {
  return {
    queryKey: ['subscriptionDates', fqn],
    queryFn: () => {
      return getSubscriptionDates({
        connection: ProviderType.CARTO_DW,
        fqn
      })
    }
  }
}

export function checkTableExists({ connection, fqn }: { connection; fqn }) {
  return {
    queryKey: ['tableExists', connection.id, fqn],
    queryFn: () => {
      return searchTableInConnection({ connection, fqn })
    },
    enabled: false
  }
}
